import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=a2d16bd8"
import script from "./Location.ts?vue&type=script&lang=ts"
export * from "./Location.ts?vue&type=script&lang=ts"
import style0 from "./Location.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports